import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const initAssignPurchaserOrders = createAction(ACTION.ASSIGN_PURCHASER_ORDERS.INIT);
export const beginAssignPurchaserOrders = createAction(ACTION.ASSIGN_PURCHASER_ORDERS.BEGIN, (orderIds, purchaserId) => ({orderIds, purchaserId}));
export const finishAssignPurchaserOrders = createAction(ACTION.ASSIGN_PURCHASER_ORDERS.FINISH);
export const assignPurchaserOrders = createAction(ACTION.ASSIGN_PURCHASER_ORDERS.REQUEST, (orderIds, purchaserId) => ({orderIds, purchaserId}));
export const assignPurchaser = createAction(ACTION.ASSIGN_PURCHASER.REQUEST, (orderId, purchaserId, single = true) => ({orderId, purchaserId, single}));
export const unassignPurchaser = createAction(ACTION.UNASSIGN_PURCHASER.REQUEST, (orderId, single = true) => ({orderId, single}));
